module.exports = __webpack_public_path__ + "img/wxkf1.4693cc6a.png";